export const STATE_CITIES_QUERY = 'state-cities';
export const USER_DATA_QUERY = 'user-data';
export const SAVE_USER_DATA_QUERY = 'save-user-data';
export const ZIP_CODE_QUERY = 'zip-code';
